import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { FeaturedProjects } from '../components/home/FeaturedProjects';
import { LatestBids } from '../components/home/LatestBids';
import { ProcurementQuickLinks } from '../components/home/ProcurementQuickLinks';
import { NewsSection } from '../components/home/NewsSection';
import { CTASection } from '../components/home/CTASection';
export function Home() {
  return <div data-id="element-753">
      <HeroSection data-id="element-754" />
      <StatsSection data-id="element-755" />
      <FeaturedProjects data-id="element-756" />
      <LatestBids data-id="element-757" />
      <ProcurementQuickLinks data-id="element-758" />
      <NewsSection data-id="element-759" />
      <CTASection data-id="element-760" />
    </div>;
}